export const appointStateList = [
  { value: 1, name: '已预约' },
  { value: -1, name: '已取消' },
  { value: 2, name: '已核销' },
];
